import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';

export class ContactBus extends BaseBus
{
  CID(): any {
      return this.personId;
  }
    constructor(data: ContactBus) {
    super(data);
  }
 personId: any;
 firstName: string;
 lastName: string;
 contactEmail: string;
 hasMobile: boolean ;
 mainNumber: string;
 cellNumber: string;
 emailPersonal: string;
 address1: string;
 address2: string;
 city: string;
 state: string;
 zip: string;
 managerId: any;

}